export enum LoadingState {
  IDLE = 'idle',
  PENDING = 'pending',
  COMPLETE = 'complete',
  FAILED = 'failed'
}
